import { rolesService } from '@/services/api/roles.service'
import { skipToken, useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../queryKeys'

async function getRolesByUser(userId: string) {
  const response = await rolesService.getRolesByUser(userId)
  return response.data
}

export function useGetRolesByUser(userId?: string) {
  return useQuery({
    queryKey: [QUERY_KEYS.roles.getAll, userId],
    queryFn: userId ? () => getRolesByUser(userId) : skipToken,
  })
}
